export default __webpack_public_path__ + "static/media/hugo_pere_lachaise.411b7d4c.jpg";